import { toJpeg } from 'html-to-image';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import download from 'downloadjs';

export const generateImageAndDownload = (imageNode: any, size: number, filename: string, onFinally: any, width?: number, height?: number) => toJpeg(
  imageNode,
  { quality: 0.5, canvasWidth: width || size, canvasHeight: height || size },
)
  .then((dataUrl) => {
    download(dataUrl, filename || 'RBH_shop.jpg');
  })
  .catch((error) => {
    // eslint-disable-next-line no-console
    console.error('oops, something went wrong!', error);
  })
  .finally(() => {
    try {
      onFinally();
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
    }
  });
export const thousandSeparator = (amount: string | number) => {
  if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
    return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  return amount;
};

export default {};
